import { JobPosting } from '../types';

export const jobPostingsData: JobPosting[] = [
  {
    id: 'job-fullstack-dev',
    title: 'Senior Full-Stack AI & Web Developer (React / Next.js / Node.js)',
    department: 'Engineering',
    workType: 'Remote (WFH)',
    experience: '3 - 6 Years',
    location: '100% Remote (Flexible Hours • Global / India)',
    employmentType: 'Full-Time',
    openings: 3,
    salaryRange: 'Competitive Base + Performance Bonus',
    badge: 'Urgent Hiring • Remote',
    shortSummary: 'Architect and develop modern, generative AI-integrated web applications using Next.js 14, TypeScript, Tailwind CSS, and scalable Node.js microservices.',
    fullJD: {
      overview: 'As a Senior Full-Stack Developer at EBON Media Solutions, you will lead the architecture and deployment of high-performance web products for US, UK, and international clients. You will build cutting-edge user interfaces and integrate modular LLM APIs, vector search pipelines, and cloud-native serverless backends.',
      responsibilities: [
        'Architect, develop, and maintain responsive, accessible web applications using React, Next.js (App Router), and TypeScript.',
        'Integrate third-party REST and GraphQL APIs, vector databases (Pinecone/Weaviate), and OpenAI / Claude / Gemini LLM endpoints.',
        'Optimize Core Web Vitals, server-side rendering (SSR), static site generation (SSG), and edge CDN caching for sub-second page loads.',
        'Write clean, modular, and testable code with end-to-end testing coverage using Jest and Playwright.',
        'Collaborate with UI/UX designers and participate in agile sprints, code reviews, and technical architecture workshops.'
      ],
      requirements: [
        '3+ years of professional hands-on experience in full-stack JavaScript / TypeScript development.',
        'Demonstrated expertise in React, Next.js, Node.js, and relational / NoSQL databases (PostgreSQL, Supabase, MongoDB).',
        'Strong grasp of state management, Tailwind CSS, component modularity, and modern CSS-in-JS patterns.',
        'Familiarity with containerization (Docker) and CI/CD pipelines (GitHub Actions, Vercel, AWS).',
        'Excellent asynchronous communication skills for remote teamwork.'
      ],
      niceToHave: [
        'Experience integrating generative AI agents, vector embeddings, and LangChain / LlamaIndex.',
        'Prior background working directly with US or UK clients in an agile agency or product studio environment.'
      ],
      perksAndBenefits: [
        '100% Remote Work flexibility with home office equipment stipend.',
        'Flexible working hours & outcome-focused culture (no micro-management).',
        'Annual learning & professional certification budget.',
        'Comprehensive health insurance for you and your dependents.'
      ]
    },
    postedDate: 'Posted 2 days ago'
  },
  {
    id: 'job-mobile-dev',
    title: 'Hybrid Mobile App Engineer (React Native & Flutter)',
    department: 'Mobile Apps',
    workType: 'Remote (WFH)',
    experience: '2 - 5 Years',
    location: '100% Remote (WFH • US/UK Client Projects)',
    employmentType: 'Full-Time',
    openings: 2,
    salaryRange: 'Competitive Base + Annual Review',
    badge: 'Remote First',
    shortSummary: 'Build silky-smooth 60fps cross-platform mobile apps for iOS and Android with offline caching, push telemetry, and biometric authentication.',
    fullJD: {
      overview: 'We are seeking a talented Hybrid Mobile App Engineer to engineer fluid, cross-platform mobile experiences for our fintech, healthcare, and retail clients across the globe. You will bridge JavaScript/Dart with native mobile modules to ensure top-tier performance on both Apple App Store and Google Play.',
      responsibilities: [
        'Design and implement cross-platform mobile apps using React Native and/or Flutter.',
        'Implement offline-first data caching, background syncing, and secure biometric authentication.',
        'Integrate native device sensors, cameras, GPS geolocation, and real-time WebSockets.',
        'Manage Apple Developer and Google Play Console build signing, release pipelines, and store compliance.',
        'Profile app performance, memory leaks, and render cycles to ensure continuous 60fps animations.'
      ],
      requirements: [
        '2 to 5 years of production mobile application engineering experience in React Native or Flutter.',
        'Deep understanding of iOS and Android design principles, touch gestures, and responsive layouts.',
        'Experience with modern state management (Redux Toolkit, Zustand, or Riverpod).',
        'Proven track record of publishing and maintaining live apps on App Store & Google Play.'
      ],
      niceToHave: [
        'Familiarity with native Swift / Kotlin bridging modules.',
        'Experience with WebRTC video calling and IoT Bluetooth Low Energy (BLE) integrations.'
      ],
      perksAndBenefits: [
        'Full work-from-home setup with high-spec developer laptop provided.',
        'Bi-annual performance bonuses and paid wellness leaves.',
        'Mentorship from seasoned mobile architects.'
      ]
    },
    postedDate: 'Posted 3 days ago'
  },
  {
    id: 'job-digital-marketing',
    title: 'Digital Marketing & Performance SEO Specialist (Google Ads & PMax)',
    department: 'Digital Marketing',
    workType: 'Work From Office (WFO)',
    experience: '2 - 4 Years',
    location: 'Work From Office (WFO • Collaborative Tech Hub)',
    employmentType: 'Full-Time',
    openings: 2,
    salaryRange: 'Attractive Salary + Target Incentive Bonus',
    badge: 'WFO Vacancy',
    shortSummary: 'Lead keyword-based search campaigns, technical SEO, and Google Shopping & Performance Max (PMax) ads for client businesses.',
    fullJD: {
      overview: 'Join our in-office growth pod as a Performance Marketing & SEO Specialist. You will strategize and execute keyword-based campaigns, Google Search Ads, Google Shopping / PMax campaigns, and organic technical SEO for informative websites, local businesses, and large e-commerce storefronts.',
      responsibilities: [
        'Conduct deep keyword research, search intent mapping, and competitor gap audits.',
        'Plan, launch, and optimize high-ROAS Google Ads (Search, Display, Shopping, and PMax campaigns).',
        'Execute comprehensive technical SEO audits, schema markup implementation, and Core Web Vitals checks.',
        'Manage Google Merchant Center product feeds, attribute optimizations, and disapproved item fixes.',
        'Generate weekly and monthly client ROI dashboards with Google Analytics 4 (GA4) and Looker Studio.'
      ],
      requirements: [
        '2 to 4 years of hands-on experience managing Google Ads campaigns with demonstrated ROAS.',
        'Google Ads Search & Shopping certifications.',
        'Strong practical expertise in Semrush, Ahrefs, Screaming Frog, and Google Search Console.',
        'Excellent written English for high-converting ad copy and headlines.'
      ],
      niceToHave: [
        'Experience handling e-commerce stores on Shopify and WooCommerce.',
        'Knowledge of programmatic SEO and local Google Business Profile rank optimization.'
      ],
      perksAndBenefits: [
        'State-of-the-art office workspace with ergonomic workstations & high-speed fiber.',
        'Daily catered refreshments, team lunches, and games lounge.',
        'Direct performance incentive bonuses tied to campaign milestones.'
      ]
    },
    postedDate: 'Posted this week'
  },
  {
    id: 'job-uiux-designer',
    title: 'UI/UX Product Designer & Design Systems Lead',
    department: 'Design & Creative',
    workType: 'Hybrid',
    experience: '3 - 5 Years',
    location: 'Hybrid (2 Days Office / 3 Days Remote)',
    employmentType: 'Full-Time',
    openings: 1,
    salaryRange: 'Competitive Base + Equity Options',
    badge: 'Hybrid Flexibility',
    shortSummary: 'Craft beautiful, intuitive digital experiences, tactile design systems, and conversion-optimized interfaces in Figma for web and mobile platforms.',
    fullJD: {
      overview: 'As our UI/UX Product Designer, you will turn complex user workflows and enterprise requirements into elegant, tactile, and user-centric interfaces. You will establish our global component design system and work hand-in-hand with frontend engineers.',
      responsibilities: [
        'Create user personas, wireframes, high-fidelity prototypes, and design specs in Figma.',
        'Maintain and expand our scalable Figma Design System with auto-layout and variable tokens.',
        'Conduct usability testing and conversion rate optimization (CRO) heuristic evaluations.',
        'Work directly with clients to translate business goals into intuitive interface patterns.'
      ],
      requirements: [
        '3+ years designing web and mobile applications with a robust public portfolio.',
        'Mastery of Figma, component properties, prototyping, and developer handoff plugins.',
        'Thorough knowledge of WCAG 2.1 accessibility guidelines and mobile touch paradigms.'
      ],
      niceToHave: [
        'Basic understanding of HTML/CSS and Tailwind CSS utility classes.',
        'Experience with motion design and micro-interactions using Lottie or Rive.'
      ],
      perksAndBenefits: [
        'Best-of-both-worlds hybrid model: in-office collaborative sprint days + quiet remote days.',
        'Figma Enterprise license and access to top design asset libraries.',
        'Regular design hackathons and international client exposure.'
      ]
    },
    postedDate: 'Posted 4 days ago'
  },
  {
    id: 'job-erp-architect',
    title: 'ERP & Custom Software Solutions Architect (Python / Cloud)',
    department: 'Engineering',
    workType: 'Work From Office (WFO)',
    experience: '4 - 8 Years',
    location: 'Work From Office (WFO • Engineering Hub)',
    employmentType: 'Full-Time',
    openings: 2,
    salaryRange: 'Premium Package Commensurate with Experience',
    badge: 'WFO Vacancy',
    shortSummary: 'Architect enterprise resource planning (ERP) platforms, multi-tenant databases, microservices, and secure procurement & billing modules.',
    fullJD: {
      overview: 'We are expanding our core enterprise solutions team. In this on-site role, you will architect secure, multi-tenant ERP suites and automated backend workflows for mid-market and enterprise partners requiring real-time inventory, procurement, and accounting intelligence.',
      responsibilities: [
        'Architect modular ERP systems featuring role-based access control, ledger automation, and inventory forecasting.',
        'Design scalable database schemas with PostgreSQL, row-level security (RLS), and Redis caching.',
        'Build and maintain RESTful / GraphQL APIs with Python (FastAPI/Django) or Node.js.',
        'Ensure institutional-grade security compliance and zero-downtime database cutovers.'
      ],
      requirements: [
        '4+ years architecting enterprise software, ERP, or SaaS multi-tenant products.',
        'Deep mastery of Python or Node.js backend ecosystems and relational database modeling.',
        'Experience designing microservices and asynchronous message queues (RabbitMQ/Kafka).'
      ],
      niceToHave: [
        'Experience integrating with SAP, Salesforce, or Oracle ERP endpoints.',
        'Cloud certifications (AWS Certified Solutions Architect or GCP Cloud Architect).'
      ],
      perksAndBenefits: [
        'Executive engineering compensation package with semi-annual appraisals.',
        'Collaborative on-site engineering war room with top tech minds.',
        'Premium healthcare coverage for employee and family.'
      ]
    },
    postedDate: 'Posted 5 days ago'
  },
  {
    id: 'job-b2b-sales',
    title: 'B2B Technical Sales & International Business Development Associate',
    department: 'Sales & BD',
    workType: 'Remote (WFH)',
    experience: '1 - 4 Years',
    location: '100% Remote (WFH • US/UK Client Outreach)',
    employmentType: 'Full-Time',
    openings: 3,
    salaryRange: 'Fixed Base + High Commission Multipliers',
    badge: 'Remote First',
    shortSummary: 'Engage US and UK business leaders, understand their custom website and mobile app requirements, and schedule discovery consultations.',
    fullJD: {
      overview: 'Join our global business expansion team to connect with founders, CTOs, and marketing leaders across North America and Europe. You will present EBON Media Solutions’ web development, mobile app, and digital marketing capabilities.',
      responsibilities: [
        'Identify and prospect prospective US and UK clients via LinkedIn Sales Navigator, email outreach, and inbound lead follow-up.',
        'Conduct initial discovery conversations to qualify project budgets, timelines, and technical requirements.',
        'Coordinate with our founder and lead architects to schedule scoping sessions and proposal presentations.',
        'Maintain accurate pipeline telemetry in HubSpot CRM.'
      ],
      requirements: [
        '1 to 4 years of experience in B2B IT services sales, software consulting, or agency outreach.',
        'Flawless spoken and written English communication skills.',
        'Self-motivated, proactive mindset comfortable working autonomously in a remote setup.'
      ],
      niceToHave: [
        'Understanding of modern web stacks, mobile frameworks, and digital marketing retainers.',
        'Existing familiarity with US and UK corporate culture and business hours.'
      ],
      perksAndBenefits: [
        'Uncapped commission structure on closed contracts.',
        'Flexible working hours aligned to international markets.',
        'Direct mentorship from senior technical leads and engineering directors.'
      ]
    },
    postedDate: 'Posted recently'
  }
];

export const employeePerks = [
  {
    title: 'Work Flexibility (Remote / WFO / Hybrid)',
    description: 'Choose from 100% Remote (WFH), collaborative Work From Office (WFO), or Hybrid setups that suit your lifestyle.'
  },
  {
    title: 'High-Impact International Projects',
    description: 'Engineer digital platforms directly for funded startups and mid-market enterprises across the United States, United Kingdom, and Europe.'
  },
  {
    title: 'Cutting-Edge AI & Modern Stacks',
    description: 'Work with Next.js 14, React Native, Flutter, Python, LLMs, and cloud-native serverless systems with zero legacy baggage.'
  },
  {
    title: 'Merit-Driven Career Progression',
    description: 'No bureaucratic corporate ladders. Rapid salary appraisals, leadership opportunities, and performance bonuses based on pure merit.'
  }
];
